import { Button } from "@/components/ui/Button"
import { Card } from "@/components/ui/Card"
import ProductPicker from "./ProductPicker"

interface Props {
  autoProducts: boolean
  picked: string[]
  searchUrl: string
  onAdd: (externalId: string) => void
  onReset: () => void
}

/** Products-row controls for the all-markets page: one picker whose list
 * applies to every market's table. */
export default function ProductsBar({ autoProducts, picked, searchUrl, onAdd, onReset }: Props) {
  return (
    <Card className="flex items-center justify-between gap-4 px-4 py-3">
      <div>
        <div className="text-sm font-semibold">{autoProducts ? "Top products by revenue" : `Picked products (${picked.length})`}</div>
        <div className="text-xs text-muted-foreground">
          {autoProducts
            ? "Each market shows its own best sellers for this period. Add products to compare one fixed list across markets."
            : "The same list in every market. Remove one with the × next to its name."}
        </div>
      </div>
      <div className="flex items-center gap-2">
        {!autoProducts && (
          <Button variant="ghost" size="sm" onClick={onReset}>
            Back to top sellers
          </Button>
        )}
        <ProductPicker searchUrl={searchUrl} picked={picked} onAdd={onAdd} />
      </div>
    </Card>
  )
}
